<template>
    <div>
        <div class="content-caption dashed">
            <span>配件信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>名称</label>
                </div>
                <div class="form-value">
                    <span>{{stockInfo.name || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>规格</label>
                </div>
                <div class="form-value">
                    <span>{{stockInfo.modelSpec || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>分类</label>
                </div>
                <div class="form-value">
                    <span>{{stockInfo.catName || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>品牌</label>
                </div>
                <div class="form-value">
                    <span>{{stockInfo.brandName || ''}}</span>
                </div>
            </div>
        </div>

        <div class="content-caption dashed">
            <span>库存信息</span>
        </div>
        <div class="table-layout">
            <el-table :data="stockList" border style="width: 100%">
                <el-table-column prop="warehouseName" label="仓库名称"></el-table-column>
                <el-table-column prop="quantity" label="数量" width="160" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.quantity != null">{{rows.row.quantity}}</span>
                        <span v-else>0</span>
                    </template>
                </el-table-column>
                <el-table-column prop="normalQuantity" label="良品数量" width="100" align="right"></el-table-column>
                <el-table-column prop="defectQuantity" label="不良品数量" width="100" align="right"></el-table-column>
                <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
                <el-table-column label="单价（元）" width="120" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import accStockApi from '../../api/accStock';

    export default {
        name: 'swb-acc-stock-list-for-acc-def',
        desc: '配件定义查看库存信息',
        props: ['merchantId', 'accId'],
        data: function () {
            return {
                stockInfo: {},
                stockList: [],
            }
        },
        created: function () {
            this.getAccDefInfo();
            //
            this.getMerchtAccStockList();
        },
        methods: {
            getAccDefInfo: function () {
                let self = this;
                let postData = {
                    id: this.accId
                };
                let theLoad = MsgBox.loading();
                accStockApi.getAccDefInfo(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.stockInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取-商户库存
            getMerchtAccStockList: function () {
                let self = this;
                let postData = {
                    merchantId: self.merchantId,
                    accId: this.accId
                };
                let theLoad = MsgBox.loading();
                accStockApi.getMerchtAccStockList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.stockList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shareAcc/AccStockListForAccDef.vue